module.exports = __webpack_public_path__ + "static/media/cy.c5123360.svg";